import { Outlet, useNavigate } from 'react-router-dom'
import Sidebar from './Sidebar'

import { useAuth } from '../../hooks/useAuth'
import { useNavLayout } from '../../hooks/useNavLayout'

export default function AppLayout(): React.JSX.Element {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const navMode = useNavLayout()

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  const isTopNav = navMode !== 'sidebar'

  return (
    <div className={`flex h-full w-full overflow-hidden bg-[var(--color-bg)] text-white ${isTopNav ? 'flex-col' : 'flex-row'}`}>
      <Sidebar user={user} onSignOut={handleSignOut} mode={navMode} />
      <main className="flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
